const state = {
  bonuses: null,
  isLoadingBonuses: false,
  bonusesError: null,
};

const mutations = {
  SET_LOADING_BONUSES(state, isLoadingBonuses) {
    state.isLoadingBonuses = isLoadingBonuses;
  },
  SET_BONUSES(state, bonuses) {
    state.bonuses = bonuses;
  },
  SET_BONUSES_ERROR(state, error) {
    state.bonusesError = error;
  },
};

const actions = {
  setLoadingBonuses({ commit }, isLoadingBonuses) {
    commit('SET_LOADING_BONUSES',  isLoadingBonuses);
  },
  setBonuses({ commit }, bonuses) {
    commit('SET_BONUSES', bonuses);
  },
};

const getters = {
  isBonusesLoading: (state) => state.isLoadingBonuses,
  isBonusesDataReady: (state) => !state.isLoadingBonuses && state.bonuses !== null,
  getBonusesAmount: (state) => Number(state.bonuses || 0),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
